// ProductProductCategories.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { faSortUp, faSortDown,faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Loader } from '../Loader/Loader';
import { Msg200or201, Msg204, Msg400, Msg401, Msg403, Msg500 } from '../Messages/Messages';
import Pagination, { usePagination } from '../Components/Pagination';
import Search from '../Components/Search';
import { decryptData } from '../../utils/storageCrypto';
import { RectangleGroupIcon  } from '@heroicons/react/24/outline';


const ProductCategories = () => {
    const navigate = useNavigate();
    const [selectedMenuItem, setSelectedMenuItem] = useState(null);
    const [productCategories, setProductCategories] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const url = process.env.REACT_APP_FORE_BRICKBUCKET;
    const [showPopup, setShowPopup] = useState(false);
    const [popupMessage, setPopupMessage] = useState('');
    const [popupType, setPopupType] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: '', direction: '' });
    const [retryFunction, setRetryFunction] = useState(null);
    const [selectedCategories, setSelectedCategories] = useState([]); 
    const [selectAll, setSelectAll] = useState(false); 
    const RETRY_LIMIT = 3; 
    const [retryCount, setRetryCount] = useState(0); 
    const [roleId, setRoleId] = useState(null);
    const searchTypes = ['Category Name'];
 const [persistedSearchQuery, setPersistedSearchQuery] = useState('');
const [persistedSearchType, setPersistedSearchType] = useState(''); 
const [filteredCategories, setFilteredCategories] = useState([]);
const [searchChips, setSearchChips] = useState(() => {
  const saved = sessionStorage.getItem('categorySearchChips');
  return saved ? JSON.parse(saved) : [];
});

useEffect(() => {
  sessionStorage.setItem('categorySearchChips', JSON.stringify(searchChips));
}, [searchChips]);

    const sortArray = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });

        const sortedArray = [...productCategories].sort((a, b) => {
            if (a[key] < b[key]) {
                return direction === 'ascending' ? -1 : 1;
            }
            if (a[key] > b[key]) {
                return direction === 'ascending' ? 1 : -1;
            }
            return 0;
        });
        setProductCategories(sortedArray);
        resetToFirstPage();
    };

    const getSortIcon = (key) => {
        if (sortConfig.key === key) {
            return sortConfig.direction === 'ascending' ? faSortUp : faSortDown;
        }
        return null;
    };

    const handleCheckboxChange = (category) => {
        if (selectedCategories.includes(category)) {
            setSelectedCategories(selectedCategories.filter((c) => c !== category));
            setSelectAll(false); 
        } else {
            setSelectedCategories([...selectedCategories, category]);
            if (selectedCategories.length === productCategories.length - 1) {
                setSelectAll(true); 
            }
        }
    };

useEffect(() => {
  if (productCategories.length > 0) {
    if (persistedSearchQuery && persistedSearchType) {
      handleSearch(persistedSearchQuery, persistedSearchType);
    } else {
      setFilteredCategories(productCategories);
    }
  }
}, [productCategories]);

 useEffect(() => {
      if (persistedSearchQuery && persistedSearchType) {
        const newChip = [{
          query: persistedSearchQuery,
          type: persistedSearchType
        }];
    
        setSearchChips(newChip);
        sessionStorage.setItem('categorySearchChips', JSON.stringify(newChip));
      }
    }, [persistedSearchQuery, persistedSearchType]);



const handleSearch = (query, type) => {
  if (!query || query.trim() === '') {
    setFilteredCategories(productCategories); 
    setSearchChips([]);
  sessionStorage.removeItem('categorySearchChips');
    resetToFirstPage(); 
    return;
  }
  const lowercaseQuery = (query || '').toLowerCase(); 
  const filtered = productCategories.filter((category) => {
    switch (type) {
      case 'Category Name':
        return category.product_category_name?.toLowerCase().includes(lowercaseQuery);
      default:
        return true; 
    }
  });
  setFilteredCategories(filtered);
  resetToFirstPage(); 
};


    const handleSelectAll = () => {
        if (selectAll) {
            setSelectedCategories([]);
            setSelectAll(false);
        } else {
            setSelectedCategories(productCategories);
            setSelectAll(true);
        }
    };

    const handleCreate = () => {
        navigate("/bb/app/items/newproductcategory");
    };


    const handleNavigateProductCategoryDetails = (category) => {
        navigate("/bb/app/items/productcategorydetails", { state: { ProductCategoryData: category } })
        console.log(category);
    }

    
    const categoriesToDisplay = filteredCategories.length > 0 || persistedSearchQuery
    ? filteredCategories
    : productCategories;

if (roleId === 6) {
    categoriesToDisplay = categoriesToDisplay.filter(
        (category) => category.product_category_name.toLowerCase() === 'tiles'
    );
}

    
   const {
    currentItems,
    currentPage,
    totalPages,
    totalItems,
    handlePageChange,
    handlePreviousPage,
    handleNextPage,
    resetToFirstPage
} = usePagination(categoriesToDisplay, 10);

   

    useEffect(() => {
  const savedSearchChips = JSON.parse(sessionStorage.getItem('categorySearchChips')) || [];
  setSearchChips(savedSearchChips);

  if (savedSearchChips.length > 0) {
    const lastChip = savedSearchChips[0];
    setPersistedSearchQuery(lastChip.query);
    setPersistedSearchType(lastChip.type);
  }

  fetchRoleId();
  fetchProductCategories();
}, []);

    const fetchRoleId = () => {
        const encryptedroleId = sessionStorage.getItem('roleId');
        const sroleId = decryptData(encryptedroleId);
        setRoleId(sroleId);
    };

    const fetchProductCategories = async (attempt = 1) => {
        try {
                const encryptedToken = sessionStorage.getItem('token');
                    const token = decryptData(encryptedToken);
               const encryptedhubId = sessionStorage.getItem('hubId');
              const hubId = decryptData(encryptedhubId);
       const response = await fetch(`${url}product-category/get-all-productCategories?hubId=${hubId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'x-token': token
                }
            }); // Update productCategories state
            const data = await response.json();
            console.log('API Response:', data);
            if (data.status === 200 || data.status === 201) {
                setProductCategories(data.data);
            } else {
                setPopupMessage(data.message);
                setPopupType(`${data.status}`);
                setShowPopup(true);
            }
        } catch (error) {
            console.error('Failed to fetch:', error);

            if (attempt < RETRY_LIMIT) {
                setRetryCount(attempt + 1); // Increment retry count
                setTimeout(() => fetchProductCategories(attempt + 1), 1000); // Retry after 1 second
            } else {
                setIsLoading(false);
                setPopupMessage('Internal Server Error. Kindly Retry.');
                setPopupType('500');
                setShowPopup(true);
                setRetryFunction(() => () => fetchProductCategories(attempt)); // Set retry function
            }
        } finally {
            setIsLoading(false);
        }
    }

    if (isLoading) {
        return <Loader />;
    }

    const handleDelete = async (attempt = 1) => {
        const selectedCategoryIds = selectedCategories.map((category) => category._id);
        console.log(selectedCategoryIds);
        try {
               const encryptedToken = sessionStorage.getItem('token');
                   const token = decryptData(encryptedToken);

            const response = await fetch(process.env.REACT_APP_FORE_BRICKBUCKET + "product-category/delete-product-categories", {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'x-token': token
                },
                body: JSON.stringify({ productCategoryIds: selectedCategoryIds })
            });

            const data = await response.json();
            if (data.status === 200 || data.status === 201 || data.status === 204) {
                // Update the vendors state to reflect the deleted vendors
                setProductCategories(productCategories.filter((category) => !selectedCategoryIds.includes(category._id)));
                setSelectedCategories([]);
                setSelectAll(false);
                // Reset to first page after deletion
                resetToFirstPage();
            } else {
                // Handle error cases
                setPopupMessage(data.message);
                setPopupType(`${data.status}`);
                setShowPopup(true);
            }
        } catch (error) {
            console.error('Failed to fetch:', error);

            if (attempt < RETRY_LIMIT) {
                setRetryCount(attempt + 1); // Increment retry count
                setTimeout(() => handleDelete(attempt + 1), 1000); // Retry after 1 second
            } else {
                setIsLoading(false);
                setPopupMessage('Internal Server Error. Kindly Retry.');
                setPopupType('500');
                setShowPopup(true);
                setRetryFunction(() => () => handleDelete(attempt)); // Set retry function
            }
        }
    };

    const closePopup = () => {
        console.log("closePopup called");
        setShowPopup(false);
    };

    const Retry = async () => {
        console.log("Retry called");
        setTimeout(async () => {
            if (retryFunction) {

                await retryFunction();
            }

            setIsLoading(false)
        }, 1000)

        setShowPopup(false);
    };

    const BackToLoginPage = () => {
        console.log("Back To Login Page");
        setShowPopup(false);
        localStorage.removeItem('LoginData');
        sessionStorage.removeItem('userData');
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('userId');
        sessionStorage.removeItem('appId');
        navigate('/bb');
    };

const handleRemoveSearchChip = () => {
  setSearchChips([]);
  sessionStorage.removeItem('categorySearchChips');

  setPersistedSearchQuery('');
  setPersistedSearchType('');
 setFilteredCategories(productCategories);
};


const handleAddSearchChip = (query, type) => {
  if (!type) return;

  const actualQuery = query.trim();

  const newChip = [{ query: actualQuery, type }]; // only one chip

  setSearchChips(newChip);
  sessionStorage.setItem('categorySearchChips', JSON.stringify(newChip));

  setPersistedSearchQuery(actualQuery);
  setPersistedSearchType(type);

  handleSearch(actualQuery, type);
};

  




  const handleChipClick = (chip) => {
  setPersistedSearchType(chip.type);
  setPersistedSearchQuery(chip.query);
  handleSearch(chip.query, chip.type);
};


    return (
        <div className="bg-white flex flex-row w-full justify-left h-full overflow-y-hidden">
            <div className="flex flex-row w-full">
                <div className="w-full flex-1">
                    <div className="flex flex-col w-full justify-center items-center">
                        <div className="w-full h-full flex flex-col justify-between">
                            <div className="w-full h-16 border-b flex items-center">
                                <div className="flex w-full justify-between px-4 items-center">
                                    {selectedCategories.length > 0 ? (
                                        <button
                                            className="bg-gray-100 px-2 py-1 shadow-sm text-sm border rounded-md ">Delete</button>
                                    ) : (
                                        <>
                                            <div className='space-x-10 flex flex-row mt-4 mb-4'>

                                            <h1 className="text-lg font-bold whitespace-nowrap">All Item Categories</h1>
                                            {productCategories.length > 0 && (
                                              <>
                                            <Search
                                            searchQuery={persistedSearchQuery}
                                            setSearchQuery={setPersistedSearchQuery}
                                           searchType={persistedSearchType}
                                           setSearchType={setPersistedSearchType}
                                            searchTypes={searchTypes}
                                            onSearch={handleSearch}
                                            onSearchSubmit={handleAddSearchChip}
                                           placeholder="Search categories..."
                                          />
                                           

{searchChips.length > 0 && (
  <div className="w-full flex flex-row gap-3 items-center mt-2 px-4"> {/* Changed flex-cols to flex-row */}
    {searchChips.map((chip, index) => {
      const isActive = chip.type === persistedSearchType;

      const chipClasses = `flex items-center max-w-xs text-sm px-3 py-1 rounded-full shadow-sm transition-all duration-150 ${
        isActive
          ? 'bg-red-500 text-white'
          : 'bg-gray-100 text-gray-800'
      }`;

      return (
        <div
           key={`${chip.type}-${chip.query}-${index}`} // Better unique key
      className={chipClasses}
      style={{ whiteSpace: 'nowrap' }}
      onClick={() => handleChipClick(chip)}
    >
      <span className="whitespace-nowrap ">
        {chip.type}: {chip.query}
      </span>
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              handleRemoveSearchChip(chip);
            }}
            className={`ml-2 text-base font-bold ${
              isActive ? 'text-white hover:text-gray-200' : 'text-gray-500 hover:text-red-500'
            }`}
          >
            ×
          </button>
        </div>
      );
    })}
  </div>
)}
</>
 )}
</div>
                                            <button onClick={handleCreate}
                                                className="bg-[#E54643] text-white z-20 px-2 py-1 rounded"
                                                title="" data-tooltip="Create Item Category" style={{ '--tooltip-bg': 'black' }}>
                                                + New</button>
                                        </>
                                    )}
                                </div>
                            </div>

                              <Pagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                totalItems={totalItems}
                                itemsPerPage={10}
                                showInfo={true}
                                 hideControls={true} 
                                itemName="categories"
                            />

                            <div className="w-full flex-1 bg-white rounded-xs overflow-hidden">
                                <div className="overflow-y-auto h-[70vh]">
                                 {(productCategories.length > 0 || persistedSearchQuery) ? (
  <>
    <table className="w-full mb-5">
      <thead className="sticky top-0 bg-[#fafafc] text-[#6c7184] border-b">
        <tr className="border-b">
          <th className="text-xs py-3 text-center">
            <input
              type="checkbox"
              className="mr-2"
              onChange={handleSelectAll}
              checked={selectAll}
            />
          </th>

          <th
            className="text-xs py-3 text-center cursor-pointer"
            onClick={() => sortArray('product_category_name')}
          >
            ITEM CATEGORY NAME
            {getSortIcon('product_category_name') && (
              <FontAwesomeIcon icon={getSortIcon('product_category_name')} />
            )}
          </th>

          <th className="text-xs py-3 text-center">
            CATEGORY DESCRIPTION
          </th>
        </tr>
      </thead>

      <tbody className="border-b border-t">
        {currentItems.length > 0 ? (
          currentItems.map((category, index) => (
            <tr key={index} className="text-sm border-b">
              <td className="py-2 text-center">
                <input
                  type="checkbox"
                  className="mr-2"
                  onChange={() => handleCheckboxChange(category)}
                  checked={selectedCategories.includes(category) || selectAll}
                />
              </td>

              <td
                onClick={() => handleNavigateProductCategoryDetails(category)}
                className="py-2 px-3 text-center text-[#408dfb] font-500 cursor-pointer"
              >
                {category.product_category_name}
              </td>

              <td className="py-2 px-3 text-center w-1/2 break-all">
                {category.product_category_description}
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="10" className="text-center text-[#6c7184] py-6">
              <div className="flex flex-col items-center">
                <FontAwesomeIcon
                  icon={faSearch}
                  className="text-4xl text-gray-300 mb-4"
                />
                <p className="text-lg font-medium mb-2">
                  No Results Found.
                </p>
                <p className="text-sm">
                  Try adjusting your search criteria.
                </p>
              </div>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </>
) : (
  <>
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-8 mx-4 mt-4">
                     <div className="text-center text-gray-500">
                       <div className="mb-4">
                         <RectangleGroupIcon   className="mx-auto h-12 w-12 text-gray-300" />
                       </div>
                       <h3 className="text-lg font-medium mb-2">No Categories Found</h3>
                       <p className="text-sm">Categories will appear once they are created.</p>
                     </div>
                      <div className="flex justify-center items-center mt-4">
                           <button className="bg-[#F7525A] text-white px-2 py-1 rounded-md" onClick={handleCreate}>Create</button>
                         </div>
                   </div>
 
  </>
)}

</div>
                            </div>
                           <div className="sticky bottom-0 bg-white  z-10 px-4 py-2">

                            <Pagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                totalItems={totalItems}
                                itemsPerPage={10}
                                onPageChange={handlePageChange}
                                onPreviousPage={handlePreviousPage}
                                onNextPage={handleNextPage}
                                  showInfo={false}
                                itemName="categories"
                            />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {showPopup && (
                <div>
                    {popupType === '400' && <Msg400 message={popupMessage} closePopup={closePopup} />}
                    {popupType === '401' && <Msg401 message={popupMessage} closePopup={BackToLoginPage} />}
                    {popupType === '403' && <Msg403 message={popupMessage} closePopup={BackToLoginPage} />}
                    {popupType === '500' && <Msg500 message={popupMessage} closePopup={Retry} cancelPopup={closePopup} />}
                </div>
            )}

               
        </div>
    );
};

export default ProductCategories;
